import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TypeCPVClass } from '../models/TypeCPVClass';
@Component({
  selector: 'app-typeCPV-class',
  templateUrl: './typeCPV-class.component.html'
})
export class TypeCPVClassComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'TypeCPVClass'
  @Input() parentForm: FormGroup;
  	@Input() objetPrincipal : TypeCPVClass;

  constructor() { }

  public ngOnInit() {
  }


  addclassSupplementaire(){
		this.objetPrincipal.classSupplementaire.push('ClassSupplementaire');
	}

  removeclassSupplementaire(i){
		this.objetPrincipal.classSupplementaire.splice(i, 1);
	}



  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }


}

